export default __webpack_public_path__ + "static/media/icon-video-consult.e1d24a5b.svg";